import { useEffect, useRef, useState } from 'react';

import {
  ChevronDown,
  ChevronUp,
  DropDownMainContainer,
  MenuTitle,
  fieldContainer,
  widthStyling
} from './DropDownStyle';
import { triggerMixpanelForCTAEvent } from '../../../utils/dropDownHandler';
import { WINDOW_LISTNER_EVENTS } from '../../../utils/GlobalListners/WindowListnerConstants';
import useWindowEvent from '../../../utils/GlobalListners/WindowListnerHook';
import { isSpaceForDropDown } from '../../../utils/TvShowDetailsHelper/tvShowDetailsHandler';
import DropDownModal from '../DropDownModal/DropDownModal';

interface DropDownProps {
  intervalData: string[];
  changeEventHandler?: (index: number) => Promise<void> | void;
  setSelectedOption?: (name: string, value: string) => void;
  triggerMixpanelFlag?: boolean;
  seriesTitle?: string;
  activeSeasonIndex?: number;
  country?: string;
  isContactUs?: boolean;
  isFormReset?: boolean;
  type?: string;
  item?: string;
}

const DropDown = (dropDownData: DropDownProps) => {
  const {
    intervalData = [],
    changeEventHandler,
    triggerMixpanelFlag,
    seriesTitle = '',
    activeSeasonIndex = 0,
    country,
    isContactUs = false,
    isFormReset = false,
    type = '',
    item = '',
    setSelectedOption
  } = dropDownData;

  // active season is added as the page re-renders in case of multiseason so to maintain the index which has been clicked we maintain the index
  const [selectedItem, setSelectedItem] = useState<string>(
    intervalData?.[activeSeasonIndex as number]
  );
  const [showItem, setShowItem] = useState(false);
  const [positionDownwards, setPositionDownwards] = useState(false);
  const [selectedDropDownIndex, setSelectedDropDownIndex] = useState<number>(
    activeSeasonIndex as number
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isFormReset && item) {
      handleOptionClick(item, 0);
      handleCloseForFropDown();
    }
  }, [isFormReset]);

  useEffect(() => {
    setSelectedItem(intervalData?.[activeSeasonIndex]);
    setSelectedDropDownIndex(activeSeasonIndex as number);
  }, [activeSeasonIndex, intervalData]);
  useEffect(() => {
    const handleScroll = () => {
      const positionDirection = isSpaceForDropDown(dropdownRef, 172);
      setPositionDownwards(positionDirection);
    };

    // subscripting to the event
    if (showItem === true) {
      window.addEventListener('scroll', handleScroll);
    } else if (showItem === false) {
      window.removeEventListener('scroll', handleScroll);
    }
    // unsubscriping to the event on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleCloseForFropDown);
    };
  }, [showItem]);

  // dropDown implementation
  const handleOnClick = (): void => {
    setShowItem((prevState: boolean) => !prevState);
    const positionDirection = isSpaceForDropDown(dropdownRef, 172);
    setPositionDownwards(positionDirection);
    if (triggerMixpanelFlag && seriesTitle) {
      triggerMixpanelForCTAEvent(triggerMixpanelFlag, seriesTitle, country);
    }
  };

  // outside handle click of event
  const handleCloseForFropDown = () => {
    setShowItem(false);
  };

  // on click of the episode interval
  const handleOptionClick = (item: string, index: number) => {
    setSelectedItem(item);
    if (isContactUs && type && setSelectedOption) {
      setSelectedOption(type, item);
    } else if (changeEventHandler) {
      changeEventHandler(index + 1);
    }
    setSelectedDropDownIndex(index);
    setShowItem((prevState: boolean) => !prevState);
  };
  //handle close outside of the dropDown
  const handleClickOutside = (event: Event) => {
    if (!dropdownRef?.current?.contains(event.target as Node)) {
      handleCloseForFropDown();
    }
  };

  useWindowEvent(WINDOW_LISTNER_EVENTS.MOUSEDOWN, handleClickOutside);

  return (
    <div data-testid="mainDropDownContainer" css={widthStyling(isContactUs)}>
      {selectedItem && (
        <DropDownMainContainer ref={dropdownRef} isContactUs={isContactUs}>
          <div css={fieldContainer(isContactUs)} data-testid="menuTitle">
            <MenuTitle isContactUs={isContactUs} onClick={handleOnClick}>
              <span>{selectedItem}</span>
              <div css={showItem ? ChevronDown : ChevronUp} />
            </MenuTitle>
          </div>
          {showItem && (
            <DropDownModal
              isContactUs={isContactUs}
              data-testd="dropDownModal"
              intervalData={dropDownData?.intervalData}
              handleOptionClick={handleOptionClick}
              positionDownwards={positionDownwards}
              selectedDropDownIndex={selectedDropDownIndex}
            />
          )}
        </DropDownMainContainer>
      )}
    </div>
  );
};

export default DropDown;
